/**
 * Compact 中 / EN toggle. Lives in the AppShell next to the music picker.
 *
 * When the parent has forced a language for this child, the switcher renders
 * disabled with a tooltip explaining why. The active language is still
 * displayed so the child knows which one is in effect.
 */
import { getLang, isLangForced, setLang, t, useLang } from '../i18n';

interface Props {
  /** 'login' floats top-right (no bottom nav present); default sits above the nav. */
  variant?: 'default' | 'login';
}

export default function LangSwitcher({ variant = 'default' }: Props = {}) {
  const lang = useLang();
  void lang; // re-render trigger; we read from getLang() below for symmetry
  const active = getLang();
  const locked = isLangForced();

  function flip() {
    if (locked) return;
    setLang(active === 'zh' ? 'en' : 'zh');
  }

  return (
    <button
      type="button"
      className={`app-lang-switch ${variant === 'login' ? 'app-lang-switch--login' : ''} ${locked ? 'locked' : ''}`}
      onClick={flip}
      aria-label={t('lang.switch.aria')}
      aria-pressed={active === 'en'}
      title={locked ? t('lang.switch.locked.tooltip') : ''}
      disabled={locked}
    >
      <span className={`opt ${active === 'zh' ? 'on' : ''}`}>{t('lang.zh.short')}</span>
      <span className="sep" aria-hidden>/</span>
      <span className={`opt ${active === 'en' ? 'on' : ''}`}>{t('lang.en.short')}</span>
    </button>
  );
}
